import { useContext } from 'react';
import { GlobalModalContext } from '@context/globalModalContext';
import slides from '../api/profileStrengthData';

const useStrengthModal = () => {
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const openModal = hash => {
        const slide = slides.find(s => s.hash === hash);
        if (!slide) return;
        setModalChildren(slide.modalComponent);
        setIsModalOpen(true);
    };

    return { openStrengthModal: openModal };
};

export default useStrengthModal;
